import { render, staticRenderFns } from "./HubungiKami.vue?vue&type=template&id=af6905b4&scoped=true"
import script from "./HubungiKami.vue?vue&type=script&lang=js"
export * from "./HubungiKami.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6905b4",
  null
  
)

export default component.exports